import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	MOBILE_L_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	DESKTOP_M_BP,
	TABLET_BP,
	COLOR_LIGHT_GREY_CYAN,
	COLOR_LIGHT_GREY,
	COLOR_HYPERLINK,
} from "@website-builder/utilities-index";

export const PartnerWrapper = styled.div`
	display: flex;
	flex-flow: wrap;
	.jobOpenings {
		padding: 60px 60px 60px 175px;
		background-color: ${COLOR_LIGHT_GREY_CYAN};
		width: 50%;
		.openingsHeading {
			font-size: 28px;
			font-weight: ${FONT_WT_MEDIUM};
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		.description {
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			line-height: 1.69;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			width: 407px;
			padding-top: 20px;
			padding-bottom: 20px;
		}
		.ctaWrapper {
			margin-bottom: 40px;
			margin-top: 10px;
		}
	}
	.partnership {
		padding: 60px 60px 60px 60px;
		background-color: ${COLOR_LIGHT_GREY};
		width: 50%;
		.partnershipHeading {
			font-size: 28px;
			font-weight: ${FONT_WT_MEDIUM};
			color: ${COLOR_TEXT_PRIMARY_B2C};
		}
		.partnerContainer {
			display: flex;
			flex-flow: wrap;
			padding-top: 30px;
			padding-bottom: 20px;
			.textContainer {
				.textWrapper {
					display: flex;
				}
				.partnershipText {
					width: 230px;
					font-size: 16px;
					font-weight: ${FONT_WT_LIGHT};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					padding-top: 12px;
					padding-bottom: 10px;
				}
			}
			.urlContainer {
				margin-left: 40px;
				.textWithUrl {
					font-size: 16px;
					font-weight: ${FONT_WT_MEDIUM};
					color: ${COLOR_HYPERLINK};
					padding-top: 12px;
					padding-bottom: 10px;
					text-decoration: underline;
					cursor: pointer;
					a {
						color: inherit;
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${DESKTOP_M_BP}px) {
		.jobOpenings {
			padding: 45px 60px 25px 60px;
			width: 100%;
			.openingsHeading {
				font-size: 26px;
				text-align: center;
			}
			.description {
				width: 100%;
				text-align: center;
				margin: auto;
				padding-left: 20px;
				padding-right: 20px;
			}
			.ctaWrapper {
				text-align: center;
			}
		}
		.partnership {
			width: 100%;
			.partnershipHeading {
				text-align: center;
				font-size: 26px;
			}
			.partnerContainer {
				justify-content: center;
			}
		}
	}

	@media only screen and (max-width: ${TABLET_BP - 1}px) {
		.jobOpenings {
			padding: 45px 15px 45px 15px;
			.ctaWrapper {
				margin-bottom: 10px;
			}
		}
		.textContainer {
			text-align: center;
			.textWrapper {
				display: block !important;
				.urlContainer {
					margin: auto;
				}
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.jobOpenings {
			.description {
				padding-left: 0px;
				padding-right: 0px;
			}
			.ctaWrapper {
				margin-bottom: 10px;
				a {
					button {
						padding: 0px 20px;
					}
				}
			}
		}
		.partnership {
			padding: 45px 15px 45px 15px;
			.textWrapper {
				margin-bottom: 20px;
			}
			.partnerContainer {
				padding-bottom: 0px;
				padding-top: 20px;
			}
			.partnerContainer .urlContainer .textWithUrl {
				padding-top: 5px;
			}
		}
	}
`;
